module.exports = __webpack_public_path__ + "img/icon-dashboard-large.ca11b524.svg";